var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __param = (this && this.__param) || function (paramIndex, decorator) {
    return function (target, key) { decorator(target, key, paramIndex); }
};
import { Lifecycle, injectAll, injectable } from 'tsyringe';
import { ILoggerToken, LogLevel } from './ILogger.js';
import { services } from '@quandis/qbo4.ui';
import { ILogReaderToken } from './ILogReader.js';
import { ILoggerServiceToken } from './ILoggerService.js';
import { RESOURCES } from './Program.js';
let LoggerService = class LoggerService {
    constructor(loggers, readers) {
        this.loggers = loggers;
        this.readers = readers;
        this.logTrace(`LoggingService.constructor loaded with ${loggers.length} loggers and ${readers.length} readers.`);
    }
    logTrace(message, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: LogLevel.Trace, message: message, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.logTrace(message, ...args);
        }
    }
    logDebug(message, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: LogLevel.Debug, message: message, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.logDebug(message, ...args);
        }
    }
    logInformation(message, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: LogLevel.Information, message: message, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.logInformation(message, ...args);
        }
    }
    logWarning(message, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: LogLevel.Warning, message: message, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.logWarning(message, ...args);
        }
    }
    logError(message, error, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: LogLevel.Error, message: message, error, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.logError(message, error, ...args);
        }
    }
    logCritical(message, error, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: LogLevel.Critical, message: message, error, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.logCritical(message, error, ...args);
        }
    }
    log(level, message, error, ...args) {
        window.dispatchEvent(new CustomEvent(RESOURCES.WRITING_LOG, { detail: { logLevel: level, message: message, error, ...args }, bubbles: true, cancelable: true, composed: true }));
        for (const logger of this.loggers) {
            logger.log(level, message, error, ...args);
        }
    }
    /**
     * Retrieves all log entries.
    */
    getLogs() {
        return this.readers.reduce((accumulatedLogs, reader) => {
            const logs = reader.getLogs();
            return accumulatedLogs.concat(logs);
        }, []);
    }
    /**
     * Clears all log entries from memory.
     */
    clearLogs() {
        this.readers.forEach(reader => reader.clearLogs());
    }
};
LoggerService = __decorate([
    injectable(),
    __param(0, injectAll(ILoggerToken)),
    __param(1, injectAll(ILogReaderToken)),
    __metadata("design:paramtypes", [Array, Array])
], LoggerService);
export { LoggerService };
services.container.register(ILoggerServiceToken, { useClass: LoggerService }, { lifecycle: Lifecycle.Singleton });
//# sourceMappingURL=LoggerService.js.map